import * as Yup from "yup";

const WaitlistFormSchema = Yup.object().shape(
  {
    firstname: Yup.string().required("First name required"),
    lastname: Yup.string().required("Last name required"),
    email: Yup.string().when("phone", {
      is: val => val === undefined,
      then: Yup.string()
        .email("A valid email address is required")
        .required("Either phone or email required")
        .typeError("A valid email address is required"),
      otherwise: Yup.string()
        .email()
        .typeError("A valid email address is required")
    }),
    phone: Yup.number().when("email", {
      is: val => val === undefined,
      then: Yup.number("Phone number can only consist of numbers")
        .required("Either phone or email required")
        .typeError("Phone number can only consist of numbers"),
      otherwise: Yup.number().typeError(
        "Phone number can only consist of numbers"
      )
    }),
    service: Yup.string().required("Service required"),
    staff: Yup.string().required("Staff required"),
    startdate: Yup.object()
      .nullable()
      .required("Start date required"),
    enddate: Yup.object()
      .nullable()
      .required("End date required"),
    starttime: Yup.string()
      .nullable()
      .required("Start time required"),
    endtime: Yup.string()
      .nullable()
      .required("End time required")
  },
  ["phone", "email"]
);

export default WaitlistFormSchema;
